import { Link, useLocation } from "react-router-dom";
import CustomText from "../components/atomic/CustomText";
import LandingPageLayout from "../layouts/LandingPageLayout";

function NotFoundPage(): JSX.Element {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith("/access");

  const content = (
    <div className="flex flex-col h-full w-full justify-center items-center space-y-4 text-center p-6">
      <CustomText
        text={"404 | Page not found"}
        fontWeight="font-semibold"
        fontSize="text-2xl"
      />
      <p className="text-base text-gray-700">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to={isAdminPath ? "/access/dashboard" : "/"}
        className="text-royalBlue font-medium underline"
      >
        {isAdminPath ? "Back to dashboard" : "Back to home"}
      </Link>
    </div>
  );

  if (isAdminPath) {
    // Admin layout already wraps this component, so avoid nesting another layout.
    return content;
  }

  return (
    <LandingPageLayout pageTitle={"Page Not Found | CSTL"}>
      {content}
    </LandingPageLayout>
  );
}

export default NotFoundPage;

